import { Component, OnInit, ViewChild, ElementRef, ViewChildren } from '@angular/core';
import { ProjectDetails, NewProjects } from '../../seller/seller';
import { CognitoUtil } from '../../authentication/service/cognito.service';
import { FirebaseHelperService } from '../../core/firebase/firebase-helper.service';
import { WorkerService } from '../service/worker.service';
import { WorkerInfo } from '../worker';
import { SellerApiService } from '../../seller/service/seller-api.service';
import { MessageModel } from '../../core/firebase/models/message.model';
import { CommonConstants } from '../../core/common.constants';
import { UploadEvent, UploadFile, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { ScrollEvent } from 'ngx-scroll-event';

import * as JSZip from 'jszip';
import * as JSZipUtils from 'jszip';
import * as JSZipSupport from 'jszip';
import { GlobalEventsManager } from '../../app-global-events-manager';
import { environment } from '../../../environments/environment';

// jQuery Sign $
declare let $: any;

@Component({
  selector: 'app-worker-safetybox',
  templateUrl: './worker-safetybox.component.html',
  styleUrls: ['./worker-safetybox.component.scss']
})
export class WorkerSafetyboxComponent implements OnInit {

  // define worker name
  workerFirstname: string;
  buyerDisplayName: string;
  agreedProjects: Array<NewProjects> = [];
  archiveProjects: Array<NewProjects> = [];
  completedProjects: Array<NewProjects> = [];
  archiveCompletedProjects: Array<NewProjects> = [];
  workerInfo: WorkerInfo;

  public currentWorkerUserId: number = null;
  public currentWorkerId: number = null;
  public currentSellerUserId: number = null;
  public currentSellerId: number = null;
  public currentprojectId: number = null;
  currentWorkerProfilePic: string;
  // Project Details In Safety box
  projectDetails: ProjectDetails = new ProjectDetails();
  isVisibleNewProject: boolean;
  loaderActivate: boolean;
  isDataAvailable: boolean;
  // tslint:disable-next-line:no-inferrable-types
  isActiveIndex: number = 0;
  // tslint:disable-next-line:no-inferrable-types
  isActiveArchiveIndex: number = 0;

   // tslint:disable-next-line:no-inferrable-types
   tabIndentification: string = 'activeProjects';


   // File Section
   @ViewChildren('selectFileCheckBox') selectFileCheckBoxs: any;
   @ViewChild('deleteFilesConfirmationModal') deleteFilesConfirmationModal: ElementRef;
   @ViewChild('uploadFilesModalCloseBtnCoWorker') uploadFilesModalCloseBtnCoWorker: ElementRef;

   // files section properties
   public activityFiles: any[] = [];
   public selectedFileType: string = CommonConstants.FILE_TYPE_ALL;
   // tslint:disable-next-line:no-inferrable-types
   public noOfAllActivityFiles: number = 0;
   // tslint:disable-next-line:no-inferrable-types
   public loadingMoreFiles: boolean = false;
   public selectedFiles: any[] = [];
   // tslint:disable-next-line:no-inferrable-types
   public totalCount: number = 0;
   // tslint:disable-next-line:no-inferrable-types
   public imageCount: number = 0;
   // tslint:disable-next-line:no-inferrable-types
   public docCount: number = 0;
   // tslint:disable-next-line:no-inferrable-types
   public audioCount: number = 0;
   // tslint:disable-next-line:no-inferrable-types
   public videoCount: number = 0;
   // tslint:disable-next-line:no-inferrable-types
   public otherCount: number = 0;
   // tslint:disable-next-line:no-inferrable-types
   public environmentFilter: string = 'internal_activities';
   // tslint:disable-next-line:no-inferrable-types
   private filesStartNo: number = 0;
   // tslint:disable-next-line:no-inferrable-types
   private noOfFilesPerLoad: number = 12;
   @ViewChild('selectAllFilesCheckBox') public selectAllFilesCheckBox: any;
   // files section - constant data for html
   public fileTypeAll: string = CommonConstants.FILE_TYPE_ALL;
   public fileTypeImage: string = CommonConstants.FILE_TYPE_IMAGE;
   public fileTypeDoc: string = CommonConstants.FILE_TYPE_DOC;
   public fileTypeAudio: string = CommonConstants.FILE_TYPE_AUDIO;
   public fileTypeVideo: string = CommonConstants.FILE_TYPE_VIDEO;
   public fileTypeOther: string = CommonConstants.FILE_TYPE_OTHER;
   // tslint:disable-next-line:no-inferrable-types
   activeformatindex: number = 0;

     // Co Workers charts
  workerlist: Array<any> = [];
  workerInformation: any = {};

  // tslint:disable-next-line:no-inferrable-types
  public messageToSendCoWorkers: string = '';
  public messagesCoWorkers: MessageModel[] = [];
  public initialSetOfMessagesCoWorkers: Array<any> = [];
  // tslint:disable-next-line:no-inferrable-types
  private attachedFileType: string = '';
  public attachedFileDisplayUrl = '';
  public attachedFileDisplayName = '';

  public fileDataCoDisplay: Array<any> = [];
  public fileDataCoWorker: Array<any> = [];
  // tslint:disable-next-line:no-inferrable-types
  public recipientProfilePicNameInitialsCoWorker: string = '';
  // tslint:disable-next-line:no-inferrable-types
  private attachedFileTypeCoWorker: string = '';
  public attachedFileDisplayUrlCoWorker = '';
  public attachedFileDisplayNameCoWorker = '';
  // tslint:disable-next-line:no-inferrable-types
  public isScrollToBottomCoWorker: boolean = true;
  // tslint:disable-next-line:no-inferrable-types
  public uploadingAttachmentCoWorker: boolean = false;
  // tslint:disable-next-line:no-inferrable-types
  public isLoadingAttachmentsCoWorker: boolean = false;
  // tslint:disable-next-line:no-inferrable-types
  public loadingMoreMessagesCoWorker: boolean = false;
  // tslint:disable-next-line:no-inferrable-types
  private attachmentUrlCoWorker: string = '';
  // tslint:disable-next-line:no-inferrable-types
  private messagesScrollStartIndexCoWorker: number = 0;
  // tslint:disable-next-line:no-inferrable-types
  private noOfMessagesPerScrollCoWorker: number = 10;
  @ViewChild('messageTextBoxCoWorker') messageTextBoxCoWorker: ElementRef;
  @ViewChildren('selectFileCheckBoxCoWorker') selectFileCheckBoxsCoWorker: any;
  getAllCoWorkersLatestMessageOnIntinSubscription: any;
  abc: any;
  fileuploaderrormessage: string;
  unReadMessageCount: Array<any> = [];
  isInitialNotification: boolean;
  righttabIdentify: string;
  viewimageFilePath: string;
  refreshIntervalId: any;

  constructor(private workerService: WorkerService, private sellerService: SellerApiService, private cognitoService: CognitoUtil,
    private firebaseHelperService: FirebaseHelperService, private globalEventsManager: GlobalEventsManager) {
      this.globalEventsManager.sendUnreadMessageArrayEmitter.subscribe((mode) => { this.unReadMessageCount = mode; });
     }

  ngOnInit() {
    this.righttabIdentify = 'overview';
    this.workerInfo = new WorkerInfo();
    // tslint:disable-next-line:prefer-const
    let userDetails = this.cognitoService.getCurrentUser();
    this.workerFirstname = localStorage.getItem('yasoUserFirstName');
    this.loaderActivate = true;
   // userDetails.username = 'workerone@gmail.com';
    //  get current user id and  current user profile picture
    if (userDetails.username != null) {
      this.workerService.getworkerDetailsByWorker_UserName(userDetails.username).finally(() => {
        this.loaderActivate = false;
      }).subscribe(res => {
        if (res != null) {
          this.workerInfo = res;
          // Define Worker Id and Particular Seller Id Define for that Person
          this.currentWorkerUserId = res.user_id;
          this.currentWorkerId = res.worker_id;
          this.currentSellerUserId = res.seller_user_id;
          this.currentSellerId = res.seller_id;
          this.showAllAgreedProjectsByWorkerId(this.currentWorkerId);
          // tslint:disable-next-line:max-line-length
         (this.workerInfo.image_url === null) ? this.currentWorkerProfilePic = '../assets/images/worker_profileImg.png' : this.currentWorkerProfilePic = this.workerInfo.image_url;

        }
      }, err => {
        console.log(err);
      });
    }

  }

  // get All Agreed Projects By Worker_id
  showAllAgreedProjectsByWorkerId(worker_id: number) {
    this.loaderActivate = true;
    // Get Agreed Project details and Load to display in the List
    this.workerService.getAllAgreedProjectsByWorker_id(worker_id).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.agreedProjects = res;
        this.isVisibleNewProject = true;
        if (this.agreedProjects.length > 0) {
          this.isDataAvailable = true;
          if (this.agreedProjects[0].project_id && this.agreedProjects[0].project_id != null) {
            this.isInitialNotification = true;
            this.callProjectDetails(this.agreedProjects[0].project_id,
              this.agreedProjects[0].buyer_id,
              this.agreedProjects[0].buyer_first_name,
              this.agreedProjects[0].buyer_last_name, 0);
          }
        }
      }
    }, err => {
      console.log(err);
    });
  }

  // Display the Unread Messsage Count
  getTodisplayMeesageCount(projectid) {
    // tslint:disable-next-line:prefer-const
    let count = 0;
    // tslint:disable-next-line:prefer-const
    let object = this.unReadMessageCount.filter(
      item => item.projectid === projectid);
    if (object.length > 0) {
      count = object[0].count;
    }
    return count;
  }

  // Update Unread Messages
  loadUnreadMessageUpdate(value) {
    this.righttabIdentify = value;
    if (this.isInitialNotification) {
      this.isInitialNotification = false;
      this.firebaseHelperService.updateExternalMessageCoworkerLog(this.currentprojectId, this.currentSellerId, this.currentWorkerUserId);
      this.unReadMessageCount.find(v => v.projectid === this.currentprojectId).count = 0;
      this.globalEventsManager.sendMessageReadArray(this.unReadMessageCount);
    }else {
       if (this.righttabIdentify === 'message') {
        this.isInitialNotification = false;
        this.firebaseHelperService.updateExternalMessageCoworkerLog(this.currentprojectId, this.currentSellerId, this.currentWorkerUserId);
        this.unReadMessageCount.find(v => v.projectid === this.currentprojectId).count = 0;
        this.globalEventsManager.sendMessageReadArray(this.unReadMessageCount);
      }
    }
  }




  // Call the Project details By Clicking Tabs
  callProjectDetails(projectid: number, buyerId: number, buyerfirstname: string, buyerlastname: string, index: number): void {
    this.loaderActivate = true;
    if (this.tabIndentification === 'activeProjects') {
      this.isActiveIndex = index;
    } else if (this.tabIndentification === 'archive') {
      this.isActiveArchiveIndex = index;
    }
    if (this.getAllCoWorkersLatestMessageOnIntinSubscription) {
       this.getAllCoWorkersLatestMessageOnIntinSubscription.unsubscribe();
    }


    this.currentprojectId = projectid;
    this.getAllWorkersList(this.currentprojectId);

    this.sellerService.getProjectInformationByProjectId(projectid.toString(), this.currentSellerId).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.projectDetails = res;
        this.projectDetails.buyer_id = buyerId;

        this.messagesCoWorkers = [];
        this.initialSetOfMessagesCoWorkers = [];
        this.messagesScrollStartIndexCoWorker = 0;

        // Co Worker's Message Load  By Project ID
        // get all messages initially
        // tslint:disable-next-line:prefer-const
        let getAllCoWorkersMessagesOnIntinSubscription = this.firebaseHelperService.getAllCoWorkerMessages(
          this.projectDetails.project_id, this.currentSellerId).subscribe(allMessages => {

            // when no messages are available
            if (allMessages.length === 0) {
              this.messagesCoWorkers = [];
              this.initialSetOfMessagesCoWorkers = [];
            } else {

              // convert data into message model and attach push key as id
              allMessages.forEach(element => {
                let messageModel = element.payload.val();
                if (messageModel) {
                  messageModel = <MessageModel>messageModel;
                  messageModel['id'] = element.key;
                  this.initialSetOfMessagesCoWorkers.push(messageModel);
                }
              });
              // tslint:disable-next-line:max-line-length
              // after getting messages initially unsubcribe all messages watching (or else this method will get all the messages everytime database update)
              getAllCoWorkersMessagesOnIntinSubscription.unsubscribe();

              // from the initial set of messages extract set of messages to display on initial
              this.messagesScrollStartIndexCoWorker = this.initialSetOfMessagesCoWorkers.length - 1;
              this.getMessagesCoWorkersToDisplay();

            }

            // open get latest message subscription
            this.getLatestMessagesCoWorkers();
            this.isScrollToBottomCoWorker = true;

          });

        // load Files tab data
        this.environmentFilter = 'internal_activities';
        this.activeformatindex = 0;
        this.activityFiles = [];
        this.fileTypeSelected(CommonConstants.FILE_TYPE_ALL);

        if (!this.isInitialNotification  && this.righttabIdentify === 'message') {
          this.firebaseHelperService.updateExternalMessageCoworkerLog(this.currentprojectId,
            this.currentSellerId, this.currentWorkerUserId);
            this.unReadMessageCount.find(v => v.projectid === this.currentprojectId).count = 0;
            this.globalEventsManager.sendMessageReadArray(this.unReadMessageCount);
        }

      }
    }, err => {
      console.log(err);
    });
  }

   // Get Latest Messages from Co Workers
   public getLatestMessagesCoWorkers() {
    this.loadingMoreMessagesCoWorker = true;

   // tslint:disable-next-line:max-line-length
   this.getAllCoWorkersLatestMessageOnIntinSubscription = this.firebaseHelperService.getLatestCoWorkerMessages(this.projectDetails.project_id,
      this.currentSellerId)
      .subscribe(latestMessages => {
        // if latest message is not the messages array, add it into array
        if (latestMessages && latestMessages.length > 0) {
          // tslint:disable-next-line:prefer-const
          let messagearray: Array<any> = [];
          if (this.messagesCoWorkers.length > 10) {
            messagearray = this.messagesCoWorkers.slice(Math.max(this.messagesCoWorkers.length - 10, 1));
          } else {
            messagearray = this.messagesCoWorkers;
          }
          // tslint:disable-next-line:prefer-const
          let latestMessage = latestMessages[0].payload.val();
         // console.log(latestMessage);
          // tslint:disable-next-line:max-line-length
          if (latestMessage && (this.messagesCoWorkers.length === 0 || messagearray.every(m => m.id !== latestMessages[0].key) )) {
            // tslint:disable-next-line:prefer-const
            let messageModel = <MessageModel>latestMessage;
            messageModel.id = latestMessages[0].key;
            this.messagesCoWorkers.push(messageModel);
          }
        }
        this.loadingMoreMessagesCoWorker = false;
      });
  }


  // from the initial set of messages, extract set of messages to display on scroll
  getMessagesCoWorkersToDisplay() {
    this.loadingMoreMessagesCoWorker = true;

    if (this.noOfMessagesPerScrollCoWorker === 0) {
      return;
    }

    // tslint:disable-next-line:max-line-length
    // tslint:disable-next-line:prefer-const
    let startIndex = (this.messagesScrollStartIndexCoWorker - this.noOfMessagesPerScrollCoWorker < 0) ? 0 : this.messagesScrollStartIndexCoWorker - this.noOfMessagesPerScrollCoWorker;

    // tslint:disable-next-line:prefer-const
    let messagesToAdd = this.initialSetOfMessagesCoWorkers.slice(startIndex, this.messagesScrollStartIndexCoWorker);
    if (messagesToAdd.length > 0) {
      this.messagesCoWorkers = messagesToAdd.concat(this.messagesCoWorkers);
    }
    this.messagesScrollStartIndexCoWorker = startIndex;
    this.loadingMoreMessagesCoWorker = false;
  }

  public messagesContainerOnScroll(event: ScrollEvent) {
    // // if scroll reached top and if window is not scrolled && another message set to display is not generating
    if (!event.isWindowEvent && event.isReachingTop && !this.loadingMoreMessagesCoWorker) {
      this.isScrollToBottomCoWorker = false;
      this.getLatestMessagesCoWorkers();
    }

  }


   // Identify the Tab Change Left Side
   callTabIdentify(tabvalue): void {
    switch (tabvalue) {
      case 'activeProjects':
        this.tabIndentification = 'activeProjects';
        this.isVisibleNewProject = true;
        if (this.agreedProjects.length > 0) {
          this.isDataAvailable = true;
          this.callProjectDetails(this.agreedProjects[0].project_id, this.agreedProjects[0].buyer_id,
            this.agreedProjects[0].buyer_first_name,
            this.agreedProjects[0].buyer_last_name, 0);
        } else {
          this.isDataAvailable = false;
        }
        break;
      case 'archive':
        this.isVisibleNewProject = false;
        this.tabIndentification = 'archive';
        if (this.archiveCompletedProjects.length > 0) {
          this.isDataAvailable = true;
          this.callProjectDetails(this.archiveCompletedProjects[0].project_id,
            this.archiveCompletedProjects[0].buyer_id,
            this.archiveCompletedProjects[0].buyer_first_name,
            this.archiveCompletedProjects[0].buyer_last_name, 0);
        } else {
          this.isDataAvailable = false;
        }
        break;
      default:
    }
  }

  // Archive and completed project list tab identification
  callArchiveCompletedChanges(text): void {
    if (text === 'archive') {
      this.isDataAvailable = true;
      this.archiveCompletedProjects = this.archiveProjects;
    } else {
      this.isDataAvailable = true;
      this.archiveCompletedProjects = this.completedProjects;
    }

  }

  // Get the Worker's List from the Projects
  getAllWorkersList(projectid: number): void {
    this.workerlist = [];
    this.loaderActivate = true;
    // Call workers by Projects
    this.workerService.getWorkers_withProjectLead_ByprojectId(projectid).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.workerlist = res;
        // if (this.workerlist.length > 0) {
        //   this.workerInformation = this.workerlist[0];
        // }
      }
    }, err => {
      console.log(err);
    });
  }

  // Send Message Co Workers
  sendMessageCoWorkersBtnClicked(): void {
    // if attachment is available, upload it to s3 bucket
    if (this.fileDataCoWorker.length > 0) {
      this.uploadAttachedFileCoWorker();
    }else {
      if (this.messageToSendCoWorkers) {
        this.messageToSendCoWorkers = this.messageToSendCoWorkers.substring(0, this.messageToSendCoWorkers.length - 1);
        if (this.messageToSendCoWorkers) {
          this.sendMessageToCoWorkers();
        }
      } else {
        this.messageToSendCoWorkers = '';
      }
    }
  }

  sendEnterFunctionSendMessageBtnCoWorkers($vent) {
    this.sendMessageCoWorkersBtnClicked();
  }


  // upload attached file into s3 bucket
  public uploadAttachedFileCoWorker() {

    if (!this.fileDataCoWorker || this.fileDataCoWorker.length <= 0) {
      return;
    }
    let filename = '';
    this.fileDataCoWorker.forEach((element, index) => {
      this.attachedFileType = element.type;
      this.uploadingAttachmentCoWorker = true;
      filename = element.file.name;



      // call file upload
      this.sellerService.uploadAttachedFile(element.file, this.projectDetails.project_id, this.currentWorkerUserId,
        this.attachedFileType, CommonConstants.ACTIVITY_TYPE_INTERNAL, true).subscribe(res => {
          if (res !== 'No file part') {
            this.attachmentUrlCoWorker = res.activity_url;
            // send message
            // tslint:disable-next-line:prefer-const
            let newMessage = new MessageModel(this.currentWorkerUserId,
              this.currentSellerUserId, '',
              this.attachmentUrlCoWorker, res.file_type, new Date().toUTCString(), 1, filename);
            this.firebaseHelperService.sendMessageToCoWorkers(this.projectDetails.project_id,
              this.currentSellerId, this.currentWorkerUserId, newMessage);
              const link = environment.frontendlink +
              '/seller/safetybox?requestto=safetybox&requesttype=internal&projectid=' + this.projectDetails.project_id;
            // call Push notification
            this.sendPushNotification(this.projectDetails.project_id,
              this.currentWorkerUserId, this.currentSellerUserId, this.getpushnotificationfiletype(res.file_type), link);

            // call Push notification IOS
            this.sendPushNotification_ios(this.projectDetails.project_id,
              this.currentWorkerUserId, this.currentSellerUserId, this.getpushnotificationfiletype(res.file_type), link);

            // clear message typing text box and attachment details
           // this.messageToSendCoWorkers = '';
            this.removeAttachedFileCoWorker();
          }
          this.uploadingAttachmentCoWorker = false;
          // if (res) {
          //   this.attachmentUrlCoWorker = res;
          //   // send message
          //   this.sendMessageToCoWorkers();
          //   this.uploadingAttachmentCoWorker = false;
          // }
        }, err => {
          console.log(err);
          this.uploadingAttachmentCoWorker = false;
        });
      if (this.fileDataCoWorker.length - 1 === index) {
        this.removeAttachedFileCoWorker();
        this.isScrollToBottomCoWorker = true;
      }
    });
  }

   // send message - save message data into firebase database
   private sendMessageToCoWorkers() {
    // send message
    // tslint:disable-next-line:prefer-const
    let newMessage = new MessageModel(this.currentWorkerUserId,
      this.currentSellerUserId, this.messageToSendCoWorkers,
      this.attachmentUrlCoWorker, this.attachedFileType, new Date().toUTCString(), 1, '');
    this.firebaseHelperService.sendMessageToCoWorkers(this.projectDetails.project_id,
      this.currentSellerId, this.currentWorkerUserId, newMessage);
      const link = environment.frontendlink +
      '/seller/safetybox?requestto=safetybox&requesttype=internal&projectid=' + this.projectDetails.project_id;
         // call Push notification
    this.sendPushNotification(this.projectDetails.project_id,
      this.currentWorkerUserId, this.currentSellerUserId, this.messageToSendCoWorkers, link);

               // call Push notification
    this.sendPushNotification_ios(this.projectDetails.project_id,
      this.currentWorkerUserId, this.currentSellerUserId, this.messageToSendCoWorkers, link);

    // set UnRead Message Count
    this.removecountFromUnload(this.projectDetails.project_id);

    // clear message typing text box and attachment details
    this.messageToSendCoWorkers = '';
    this.removeAttachedFileCoWorker();
    this.isScrollToBottomCoWorker = true;
  }

  // Update Unread Messages
  removecountFromUnload(projectid) {
    this.unReadMessageCount.forEach((item, index) => {
      if (item.projectid === projectid) {
        this.unReadMessageCount[index].count = 0;
        this.globalEventsManager.sendMessageReadArray(this.unReadMessageCount);
      }
    });
  }

  // remove attachment Co Workers
  public removeAttachedFileCoWorker() {
    this.attachmentUrlCoWorker = '';
    this.attachedFileDisplayUrlCoWorker = '';
    this.attachedFileDisplayNameCoWorker = '';
    this.attachedFileType = '';
    this.fileDataCoWorker = [];
    this.fileuploaderrormessage = '';
    this.fileDataCoDisplay = [];
  }

  // Remove Uploaded Files
  removeAttachedFileUploadCoWorker(item: any, ind: number): void {
    if (this.fileDataCoDisplay.length > ind) {
      this.fileDataCoDisplay.splice(ind, 1);
      this.fileDataCoWorker.forEach((element, index) => {
        if (element.file.name === item.name) {
          this.fileDataCoWorker.splice(index, 1);
        }
      });
    }
  }
    // attach file by upload button click
    public attachFileByInputClickCoWorker(event) {
      this.fileDataCoWorker = [];
      if (event.target.files && event.target.files[0]) {
        for (let index = 0; index < event.target.files.length; index++) {
          this.attachFileCoWorker(event.target.files[index]);
        }
      }
    }

    // attach file by drop file into drop zone
  public attachFileByDropCoWorker(event: UploadEvent) {
    this.fileDataCoWorker = [];
    if (event.files && event.files[0]) {
      for (let index = 0; index < event.files.length; index++) {
        const fileEntry = event.files[index].fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          if (file) {
            this.attachFileCoWorker(file);
          }
        });
      }
    }
  }

  // attaching the file that uploaded by drag drop and by button click
  private attachFileCoWorker(file: File) {
    // set attachment file type and validate file size according to file type
    if (!this.setFileTypeAndValidate(file.type, file.size, file.name, 'Internal')) {
      this.fileDataCoWorker = [];
      this.fileDataCoDisplay = [];
      return;
    }
    this.fileDataCoWorker.push({ file: file, type: this.attachedFileType });
   // this.fileDataCoWorker.push(file);

    // to display attached file
    this.attachedFileDisplayNameCoWorker = file.name;

    if (this.attachedFileType === CommonConstants.FILE_TYPE_IMAGE) {
      // tslint:disable-next-line:prefer-const
      let reader = new FileReader();
      reader.onload = (event: any) => {
        this.attachedFileDisplayUrlCoWorker = event.target.result;
        this.fileDataCoDisplay.push({
          name: this.attachedFileDisplayNameCoWorker,
          url: this.attachedFileDisplayUrlCoWorker
        });
      };
      reader.readAsDataURL(file);
    }else {
      this.fileDataCoDisplay.push({
        name: this.attachedFileDisplayNameCoWorker,
        url: this.attachedFileDisplayUrlCoWorker
      });
    }
  }

  // get worker profile name to display
  getBuyerNameForInternalChat(user_id): string {
    this.workerlist.filter(val => {
      if (val.user_id === user_id) {
        if (val.name != null) {
          this.recipientProfilePicNameInitialsCoWorker = val.name.split('')[0];
        }
      }
    });
    return this.recipientProfilePicNameInitialsCoWorker;
  }

  // get worker Name to display
  getworkerFullNameTodisplay(user_id): string {
    // tslint:disable-next-line:prefer-const
    let stringname = '';
    this.workerlist.filter(val => {
      if (val.user_id === user_id) {
        if (val.name != null) {
          stringname = val.name;
        }
      }
    });
    return stringname;
  }



  // set attachment file type and validate file size according to file type
  private setFileTypeAndValidate(fileType: string, sizeInBytes: number, name: string, activitytype: string) {
    this.fileuploaderrormessage = '';
    let mainFileType = fileType.split('/')[0];

    // to determine if this is a document file or not
    if (mainFileType === 'application') {
      // tslint:disable-next-line:prefer-const
      let extension = name.split('.').splice(-1)[0].toLocaleLowerCase();
      mainFileType = this.sellerService.getMainFileType(extension);
    } else if (mainFileType === 'text') {
      // tslint:disable-next-line:prefer-const
      let extension = name.split('.').splice(-1)[0].toLocaleLowerCase();
      mainFileType = this.sellerService.getMainFileType(extension);
    } else if (mainFileType === '') {
      // tslint:disable-next-line:prefer-const
      let extension = name.split('.').splice(-1)[0].toLocaleLowerCase();
      mainFileType = this.sellerService.getMainFileType(extension);
      if (mainFileType == null) {
        if (extension === 'mp3' || extension === 'ogg' || extension === 'wav'
        || extension === 'webm' || extension === 'mmf' || extension === 'm4p' || extension === 'msv') {
          mainFileType = 'audio';
      } else if (extension === 'flv'
        || extension === 'mov' || extension === 'mp4' || extension === 'avi' || extension === 'mpeg' || extension === 'wmv') {
          mainFileType = 'video';
      } else {
        this.fileuploaderrormessage = 'File type isnot supported';
        return false;
      }
      }
    }

    switch (mainFileType) {

      case 'image':
        if (sizeInBytes > 3000000) { // image validation cannot exceed 2mb
          this.fileuploaderrormessage = 'Maximum image size cannot exceed 2mb';
          return false;
        } else {
          this.attachedFileType = CommonConstants.FILE_TYPE_IMAGE;
          return true;
        }

      case 'doc':
        if (sizeInBytes > 50000000) {// doc validation cannot exceed 50mb
          this.fileuploaderrormessage = 'Maximum document size cannot exceed 50mb';
          return false;
        } else {
          this.attachedFileType = CommonConstants.FILE_TYPE_DOC;
          (activitytype === 'External') ? this.attachedFileDisplayUrl = '../assets/images/doc.png' :
          this.attachedFileDisplayUrlCoWorker = '../assets/images/doc.png';

          return true;
        }

        case 'pdf':
        if (sizeInBytes > 50000000) {// doc validation cannot exceed 50mb
          this.fileuploaderrormessage = 'Maximum document size cannot exceed 50mb';
          return false;
        } else {
          this.attachedFileType = CommonConstants.FILE_TYPE_PDF;
          (activitytype === 'External') ? this.attachedFileDisplayUrl = '../assets/images/pdf-icon.png' :
          this.attachedFileDisplayUrlCoWorker = '../assets/images/pdf-icon.png';

          return true;
        }

        case 'key':
        if (sizeInBytes > 50000000) {// doc validation cannot exceed 50mb
          this.fileuploaderrormessage = 'Maximum document size cannot exceed 50mb';
          return false;
        } else {
          this.attachedFileType = CommonConstants.FILE_TYPE_KEY;
          (activitytype === 'External') ? this.attachedFileDisplayUrl = '../assets/images/key-icon.png' :
          this.attachedFileDisplayUrlCoWorker = '../assets/images/key-icon.png';

          return true;
        }

        case 'numbers':
        if (sizeInBytes > 50000000) {// doc validation cannot exceed 50mb
          this.fileuploaderrormessage = 'Maximum document size cannot exceed 50mb';
          return false;
        } else {
          this.attachedFileType = CommonConstants.FILE_TYPE_NUMBERS;
          (activitytype === 'External') ? this.attachedFileDisplayUrl = '../assets/images/numbers-icon.png' :
          this.attachedFileDisplayUrlCoWorker = '../assets/images/numbers-icon.png';

          return true;
        }

        case 'pages':
        if (sizeInBytes > 50000000) {// doc validation cannot exceed 50mb
          this.fileuploaderrormessage = 'Maximum document size cannot exceed 50mb';
          return false;
        } else {
          this.attachedFileType = CommonConstants.FILE_TYPE_PAGES;
          (activitytype === 'External') ? this.attachedFileDisplayUrl = '../assets/images/pages-icon.png' :
          this.attachedFileDisplayUrlCoWorker = '../assets/images/pages-icon.png';

          return true;
        }

        case 'ppt':
        if (sizeInBytes > 50000000) {// doc validation cannot exceed 50mb
          this.fileuploaderrormessage = 'Maximum document size cannot exceed 50mb';
          return false;
        } else {
          this.attachedFileType = CommonConstants.FILE_TYPE_PPT;
          (activitytype === 'External') ? this.attachedFileDisplayUrl = '../assets/images/ppt-icon.png' :
          this.attachedFileDisplayUrlCoWorker = '../assets/images/ppt-icon.png';

          return true;
        }

        case 'txt':
        if (sizeInBytes > 50000000) {// doc validation cannot exceed 50mb
          this.fileuploaderrormessage = 'Maximum document size cannot exceed 50mb';
          return false;
        } else {
          this.attachedFileType = CommonConstants.FILE_TYPE_TXT;
          (activitytype === 'External') ? this.attachedFileDisplayUrl = '../assets/images/text-icon.png' :
          this.attachedFileDisplayUrlCoWorker = '../assets/images/text-icon.png';

          return true;
        }

        case 'excel':
        if (sizeInBytes > 50000000) {// doc validation cannot exceed 50mb
          this.fileuploaderrormessage = 'Maximum document size cannot exceed 50mb';
          return false;
        } else {
          this.attachedFileType = CommonConstants.FILE_TYPE_EXCEL;
          (activitytype === 'External') ? this.attachedFileDisplayUrl = '../assets/images/excel.png' :
          this.attachedFileDisplayUrlCoWorker = '../assets/images/excel.png';

          return true;
        }

      case 'audio':
        if (sizeInBytes > 50000000) {  // audio validation cannot exceed 50mb
          this.fileuploaderrormessage = 'Maximum audio size cannot exceed 50mb';
          return false;
        } else {
          (activitytype === 'External') ? this.attachedFileDisplayUrl = '../assets/images/audio.png' :
          this.attachedFileDisplayUrlCoWorker = '../assets/images/audio.png';
          this.attachedFileType = CommonConstants.FILE_TYPE_AUDIO;
          return true;
        }

      case 'video':
        if (sizeInBytes > 50000000) { // video validation cannot exceed 50mb
          this.fileuploaderrormessage = 'Maximum video size cannot exceed 50mb';
          return false;
        } else {
          (activitytype === 'External') ? this.attachedFileDisplayUrl = '../assets/images/video.png' :
          this.attachedFileDisplayUrlCoWorker = '../assets/images/video.png';
         // this.attachedFileDisplayUrl = '../assets/images/video.png';
          this.attachedFileType = CommonConstants.FILE_TYPE_VIDEO;
          return true;
        }


      default:
        if (sizeInBytes > 50000000) { // other file types validation cannot exceed 50mb
          this.fileuploaderrormessage = 'Maximum file size cannot exceed 50mb';
          return false;
        } else {
          this.attachedFileType = CommonConstants.FILE_TYPE_OTHER;
         // this.attachedFileDisplayUrl = '../assets/images/excel.png';
          (activitytype === 'External') ? this.attachedFileDisplayUrl = '../assets/images/doc.png' :
          this.attachedFileDisplayUrlCoWorker = '../assets/images/doc.png';
          return true;
        }

    }

  }


    // convert server timestamp value to date type and return
    public getDate(timestamp: string): Date {
      return new Date(timestamp);
    }

  // return thumbnail image to display by attachment url
  public getMessageFileThumbnail(fileType: string, fileUrl: string) {
     return this.sellerService.getThumbnailImages(fileType, fileUrl);
    // // determine file type
    // switch (fileType.toLowerCase()) {
    //   case CommonConstants.FILE_TYPE_IMAGE:
    //     return fileUrl;

    //   case CommonConstants.FILE_TYPE_DOC:
    //     return '../assets/images/doc.png';

    //   case CommonConstants.FILE_TYPE_EXCEL:
    //     return '../assets/images/excel.png';

    //   case CommonConstants.FILE_TYPE_KEY:
    //     return '../assets/images/key-icon.png';

    //   case CommonConstants.FILE_TYPE_NUMBERS:
    //     return '../assets/images/numbers-icon.png';

    //     case CommonConstants.FILE_TYPE_PAGES:
    //     return '../assets/images/pages-icon.png';

    //   case CommonConstants.FILE_TYPE_PDF:
    //     return '../assets/images/pdf-icon.png';

    //     case CommonConstants.FILE_TYPE_PPT:
    //     return '../assets/images/ppt-icon.png';

    //  case CommonConstants.FILE_TYPE_TXT:
    //     return '../assets/images/text-icon.png';

    //     case CommonConstants.FILE_TYPE_AUDIO:
    //     return '../assets/images/audio.png';

    //   case CommonConstants.FILE_TYPE_VIDEO:
    //     return '../assets/images/video.png';

    //   default:
    //     return '../assets/images/doc.png';
    // }
  }

   // push notification file type
   getpushnotificationfiletype(filetype) {
    if (filetype === 'image') {
      return 'Image file';
    } else if (filetype === 'video') {
      return 'Video file';
    } else if (filetype === 'audio') {
      return 'Audio file';
    } else {
      return 'Document';
    }
  }

  // send push notification
  sendPushNotification(projectid, sendderid, recipient_id, message, link) {
    const body = {
      project_id: projectid,
      sender_id: sendderid,
      recipient_id: recipient_id,
      message: message,
      link: link
    };
    this.sellerService.sendPushNotification(body).subscribe(res => {
      if (res != null) {
      }
    }, err => {
     // console.log(err);
    });
  }


  // send push notification IOS
  sendPushNotification_ios(projectid, sendderid, recipient_id, message, link) {
    const body = {
      project_id: projectid,
      sender_id: sendderid,
      recipient_id: recipient_id,
      message: message,
      link: link
    };
    this.sellerService.sendPushNotification_ios(body).subscribe(res => {
      if (res != null) {
      }
    }, err => {
      // console.log(err);
    });
  }


  // =================================================== START SECTION FILES ===================================================
  // View Image By Click
  viewImageFile(filepath) {
    this.viewimageFilePath = filepath;
  }

  // get activity files
  public getActivityFiles(activity_type: string) {
    this.loadingMoreFiles = true;
    this.sellerService.getActivityFiles(this.projectDetails.project_id, this.currentWorkerUserId, activity_type,
      this.selectedFileType, this.filesStartNo, this.noOfFilesPerLoad).subscribe(res => {
      if (res && res.total_count && res.data) {
        this.noOfAllActivityFiles = res.total_count;

        if (this.activityFiles.length > 0) {
          this.activityFiles = this.activityFiles.concat(res.data);
        } else {
          this.activityFiles = res.data;
        }

        this.filesStartNo = this.filesStartNo + this.noOfFilesPerLoad;

        // bind data to counts display
        if (this.selectedFileType === CommonConstants.FILE_TYPE_ALL) {
          this.totalCount = (res.total_count) ? res.total_count : 0;
          this.imageCount = (res.image_count) ? res.image_count : 0;
          this.docCount = (res.doc_count) ? res.doc_count : 0;
          this.audioCount = (res.audio_count) ? res.audio_count : 0;
          this.videoCount = (res.video_count) ? res.video_count : 0;
          this.otherCount = (res.other_count) ? res.other_count : 0;
        }

      } else {
        if (this.activeformatindex === 0) {
          this.totalCount = (res.total_count) ? res.total_count : 0;
          this.imageCount = (res.image_count) ? res.image_count : 0;
          this.docCount = (res.doc_count) ? res.doc_count : 0;
          this.audioCount = (res.audio_count) ? res.audio_count : 0;
          this.videoCount = (res.video_count) ? res.video_count : 0;
          this.otherCount = (res.other_count) ? res.other_count : 0;
        }
      }
      this.loadingMoreFiles = false;

    }, err => {
      console.log(err);
      this.loadingMoreFiles = false;
    });
  }

  public fileTypeSelected(selectedFileType: string) {
    this.selectedFileType = selectedFileType;
    this.filesStartNo = 0;
    this.activityFiles = [];
    this.selectedFiles = [];
    if (this.selectAllFilesCheckBox) {
      this.selectAllFilesCheckBox.nativeElement.checked = false;
    }

    if (this.environmentFilter === 'external_activities') {
      this.getActivityFiles(CommonConstants.ACTIVITY_TYPE_EXTERNAL);
    } else {
      this.getActivityFiles(CommonConstants.ACTIVITY_TYPE_INTERNAL);
    }
  }

  callFilesFromClient(fileenvirn): void {
    this.selectedFiles = [];
    this.environmentFilter = fileenvirn;
    this.activeformatindex = 0;
    // load Files tab data
    this.fileTypeSelected(CommonConstants.FILE_TYPE_ALL);
  }
  // select or deselect all files
  public selectAllFilesClicked(isChecked: boolean) {

    // check all check boxes
    this.selectFileCheckBoxs.forEach(element => {
      element.nativeElement.checked = isChecked;
    });

    // remove all selected file
    this.selectedFiles = [];

    // if checked true, re-add all activity files into selected files
    if (isChecked) {
      this.selectedFiles = [];
      this.activityFiles.forEach(element => {
        this.selectedFiles.push(element);
      });
    }

  }

  // remove selected files from files section
  public deleteFiles(modalCloseBtn) {

    // tslint:disable-next-line:prefer-const
    let fileIdsToDelete: number[] = [];
    this.selectedFiles.forEach(element => {
      fileIdsToDelete.push(element.safety_box_file_id);
    });

    this.sellerService.deleteFiles(fileIdsToDelete).subscribe(res => {

      // remove from list
      this.selectedFiles.forEach(element => {
        // tslint:disable-next-line:prefer-const
        let indexOfItemToRemove = this.activityFiles.findIndex(m => m.safety_box_file_id === element.safety_box_file_id);

        if (indexOfItemToRemove > -1) {
          // tslint:disable-next-line:prefer-const
          let removedItem = this.activityFiles.splice(indexOfItemToRemove, 1);

          // reduce counts
          switch (removedItem[0].file_type) {

            case CommonConstants.FILE_TYPE_IMAGE:
              this.imageCount = this.imageCount - 1;
              break;

            case CommonConstants.FILE_TYPE_DOC:
              this.docCount = this.docCount - 1;
              break;

            case CommonConstants.FILE_TYPE_AUDIO:
              this.audioCount = this.audioCount - 1;
              break;

            case CommonConstants.FILE_TYPE_VIDEO:
              this.videoCount = this.videoCount - 1;
              break;

            case CommonConstants.FILE_TYPE_OTHER:
              this.otherCount = this.otherCount - 1;
              break;

          }
          this.totalCount = this.totalCount - 1;
        }
      });

      //   close modal by triggering close modal btn click
      $(this.deleteFilesConfirmationModal.nativeElement).modal('hide');
      this.selectedFiles = [];

    }, err => {
      $(this.deleteFilesConfirmationModal.nativeElement).modal('hide');
      console.log(err);
    });
  }

  // Close the Delete Modal
  declineDeleteFilesModal(): void {
    $(this.deleteFilesConfirmationModal.nativeElement).modal('hide');
  }

  // return thumbnail image to display - depends on attached file type
  public getFileThumbnail(fileUrl: string, fileType: string) {
    return this.sellerService.getThumbnailImages(fileType, fileUrl);

    // switch (fileType) {
    //   case CommonConstants.FILE_TYPE_IMAGE:
    //     return fileUrl;

    //     case CommonConstants.FILE_TYPE_DOC:
    //     return '../assets/images/doc.png';

    //   case CommonConstants.FILE_TYPE_EXCEL:
    //     return '../assets/images/excel.png';

    //   case CommonConstants.FILE_TYPE_KEY:
    //     return '../assets/images/key-icon.png';

    //   case CommonConstants.FILE_TYPE_NUMBERS:
    //     return '../assets/images/numbers-icon.png';

    //     case CommonConstants.FILE_TYPE_PAGES:
    //     return '../assets/images/pages-icon.png';

    //   case CommonConstants.FILE_TYPE_PDF:
    //     return '../assets/images/pdf-icon.png';

    //     case CommonConstants.FILE_TYPE_PPT:
    //     return '../assets/images/ppt-icon.png';

    //  case CommonConstants.FILE_TYPE_TXT:
    //     return '../assets/images/text-icon.png';

    //     case CommonConstants.FILE_TYPE_AUDIO:
    //     return '../assets/images/audio.png';

    //   case CommonConstants.FILE_TYPE_VIDEO:
    //     return '../assets/images/video.png';

    //   case CommonConstants.FILE_TYPE_OTHER:
    //     return '../assets/images/excel.png';
    // }
  }

  // update select file list
  public selectFileCheckBoxChanged(isChecked: boolean, file: any) {

    // if check add to selected file
    if (isChecked) {
      this.selectedFiles.push(file);
    }else {
      // tslint:disable-next-line:prefer-const
      let indexOfItemToRemove = this.selectedFiles.indexOf(file);
      if (indexOfItemToRemove > -1) {
        this.selectedFiles.splice(indexOfItemToRemove, 1);
      }
    }
  }

  // download selected files
  public downloadSelectedFiles() {

    // if no files selected
    if (!this.selectedFiles || this.selectedFiles.length === 0) {
      alert('Please select files to download');
      return;
    }

    // tslint:disable-next-line:prefer-const
    let zip = new JSZip();

    this.selectedFiles.forEach((element, index) => {

      // for each selected file generate blog from file url
      this.sellerService.getFileAsBlob(element.activity_file_path).subscribe(res => {

        // add blobed file into zipe
        zip.file(element.activity_file_path.split('/').slice(-1), res);

        // if all selected files are added into zip, download zip
        if (index === this.selectedFiles.length - 1) {

          zip.generateAsync({ type: 'blob' }, (metadata) => {

            // display while zip file generating
            this.loaderActivate = true;

          }).then((blob) => {

            // download zip
            // tslint:disable-next-line:prefer-const
            let downloadUrl = window.URL.createObjectURL(blob);
            window.open(downloadUrl);
            this.loaderActivate = false;

          }, function (err) {

          });
        }
      }, err => {

      });
    });

  }

  public filesContainerOnScroll(event: ScrollEvent) {
    // if scroll reached bottom and if window is not scrolled && another file set is not loading
    if (!event.isWindowEvent && event.isReachingBottom && !this.loadingMoreFiles) {
      if (this.environmentFilter === 'external_activities') {
        this.getActivityFiles(CommonConstants.ACTIVITY_TYPE_EXTERNAL);
      } else {
        this.getActivityFiles(CommonConstants.ACTIVITY_TYPE_INTERNAL);
      }
    }

  }

  // upload attached file into s3 bucket
  public uploadFileUsingFilesection() {
    if (!this.fileDataCoWorker || this.fileDataCoWorker.length <= 0) {
      return;
    }
    let namedirect = '';
    if (this.environmentFilter === 'external_activities') {
      namedirect = CommonConstants.ACTIVITY_TYPE_EXTERNAL;
    } else {
      namedirect = CommonConstants.ACTIVITY_TYPE_INTERNAL;
    }

    this.fileDataCoWorker.forEach((element, index) => {
      this.uploadingAttachmentCoWorker = true;
      // call file upload
      this.sellerService.uploadAttachedFile(element.file, this.projectDetails.project_id, this.currentWorkerUserId,
        this.attachedFileType, namedirect, false).subscribe(res => {
          this.uploadFilesModalCloseBtnCoWorker.nativeElement.click();
          if (res !== 'No file part') {
            this.attachmentUrlCoWorker = res.activity_url;
            this.uploadingAttachmentCoWorker = false;
          }

        }, err => {
          console.log(err);
          this.uploadingAttachmentCoWorker = false;
        });
      if (this.fileDataCoWorker.length - 1 === index) {
        this.uploadFilesModalCloseBtnCoWorker.nativeElement.click();
        this.removeAttachedFileCoWorker();
        this.isScrollToBottomCoWorker = true;
        this.activityFiles = [];
        this.filesStartNo = 0;
        setTimeout(() => {
          if (this.environmentFilter === 'external_activities') {
            this.getActivityFiles(CommonConstants.ACTIVITY_TYPE_EXTERNAL);
          } else {
            this.getActivityFiles(CommonConstants.ACTIVITY_TYPE_INTERNAL);
          }
        }, 1500);
      }
    });

  }



  // =================================================== END SECTION FILES ===================================================


}



// WEBPACK FOOTER //
// ./src/app/worker/worker-safetybox/worker-safetybox.component.ts